import { IEmailFields } from "../interfaces/services/IEmailFields";
import { IEmailAttachment } from "../interfaces/services/IEmailAttachment";

export class EmailComposerBuilderService {
  emailFields: IEmailFields = { attachments: [], htmlBody: "", subject: "", ccRecipients: [], toRecipients: [] };
  constructor() { }

  setRecipients = (recipients: Office.EmailAddressDetails[], recipientsToCC: string[]) => {
    this.emailFields.toRecipients = recipients;
    this.emailFields.ccRecipients = recipientsToCC;
    return this;
  };

  setSubjectAndBody = (subject: string, htmlBody: string) => {
    this.emailFields.subject = subject;
    this.emailFields.htmlBody = htmlBody;
    return this;
  };

  setAttachments = (attachments: IEmailAttachment[]) => {
    this.emailFields.attachments = attachments;
    return this;
  };

  execute = () => {
    Office.context.mailbox.displayNewMessageForm({
      toRecipients: this.emailFields.toRecipients,
      ccRecipients: this.emailFields.ccRecipients,
      subject: this.emailFields.subject,
      htmlBody: this.emailFields.htmlBody,
      attachments: this.emailFields.attachments
    });
  };
}
